import clsx from 'clsx'

type SpinnerSize = 'l' | 'm' | 's'

interface SpinnerProps {
  /** Defines the spinner size. */
  size?: SpinnerSize
  /** Defines the spinner color. */
  color?: string
  className?: string
}

const SIZE_CONFIG: Record<
  SpinnerSize,
  { box: number; center: number; radius: number; strokeWidth: number; dashArray: number }
> = {
  s: { box: 14, center: 7, radius: 6, strokeWidth: 2, dashArray: 43.96 },
  m: { box: 32, center: 16, radius: 14, strokeWidth: 4, dashArray: 100.48 },
  l: { box: 64, center: 32, radius: 29, strokeWidth: 6, dashArray: 200.96 },
}

const KEYFRAMES = `
@keyframes uikit-spinner-rotate {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(720deg); }
  100% { transform: rotate(1080deg); }
}
@keyframes uikit-spinner-dash-s {
  0% { stroke-dashoffset: 9.24; }
  50% { stroke-dashoffset: 43.96; }
  100% { stroke-dashoffset: 0.66; }
}
@keyframes uikit-spinner-dash-m {
  0% { stroke-dashoffset: 21.12; }
  50% { stroke-dashoffset: 100.48; }
  100% { stroke-dashoffset: 0.66; }
}
@keyframes uikit-spinner-dash-l {
  0% { stroke-dashoffset: 42.24; }
  50% { stroke-dashoffset: 200.96; }
  100% { stroke-dashoffset: 0.66; }
}
`

export const Spinner = ({ size = 's', color = 'var(--wpp-primary-color-500)', className }: SpinnerProps) => {
  const { box, center, radius, strokeWidth, dashArray } = SIZE_CONFIG[size]

  return (
    <span className={clsx('inline-flex', className)} role="alert" aria-busy="true">
      <style>{KEYFRAMES}</style>
      <svg
        width={box}
        height={box}
        viewBox={`0 0 ${box} ${box}`}
        style={{
          animation: 'uikit-spinner-rotate 3s linear infinite',
          transformOrigin: `${center}px ${center}px 0`,
        }}
      >
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="transparent"
          stroke={color}
          strokeLinecap="round"
          strokeWidth={strokeWidth}
          strokeDasharray={dashArray}
          style={{ animation: `uikit-spinner-dash-${size} 3s linear infinite` }}
        />
      </svg>
    </span>
  )
}
